import { useState } from "react";
import styles from "./tabview.module.css";
import { MonthPicker } from "../../../../Samvenda-Patient/UI/monthPicker/MonthPicker";

export const TabViewEnterprise = ({ values, calendar }) => {
  const [select, setSelect] = useState(0);
  return (
    <div>
      <div className={styles.toggleContainer}>
        <div className={styles.toggle}>
          {values?.map(({ label, diable }, i) => {
            return (
              <div
                key={i}
                className={styles.slider}
                style={{
                  background: i === select ? "#3592FF" : null,
                  color: i === select ? "#fff" : "#000",
                }}
                onClick={() => !diable && setSelect(i)}
              >
                <span>{label}</span>
              </div>
            );
          })}
        </div>
        {/* {!calendar && <MonthPicker />} */}
      </div>
      {values?.map(({ component }, i) => {
        return select === i && <div key={i}>{component}</div>;
      })}
    </div>
  );
};
